namespace Account
{
	export class New
		extends ui.tab.TabHTMLPresentation
	{
		private m_Form: Form;
		private m_Input: BasicInputField[];
		private m_Company: Wollmilch.CompanyObject;

		private ComponentSelect: JQuery;

		constructor( company: Wollmilch.CompanyObject )
		{
			super();

			this.m_Input		= [];
			this.m_Form			= new Form(
			{
				tag: 'div',
				orientation: 'horizontal'
			} );
			this.m_Company	= company;

			this.ComponentSelect = $();

			this.BuildForm();

			this.Display();
		}

		public rebuild( root: JQuery|ui.base.BaseHTMLElement ): New
		{
			super.rebuild( root );

			this.Display();

			return this;
		}

		public Display() : void
		{
			this.m_Root.empty();

			this.m_Root.append( this.m_Form.getElement() );
		}

		private BuildForm(): void
		{
			let formgroup = this.m_Form.newFormGroup( [ 1 ] );

			formgroup.addItem(
				{
					input: new InputText( { name: 'username', value: '' } ),
					label: new InputLabel( { value: app.getMessage( 'AUX.PERSON.DESCRIPTION.surname' ) } )
				}
			);

			formgroup = this.m_Form.newFormGroup( [ 1 ] );
			const select = new InputSelect( { name: 'company', classes: [ 'form-control' ] }, { 'Bitte wählen ...': '' } );
			formgroup.addItem(
			{
				input: select,
				label: new InputLabel( { value: app.getMessage( 'Account.New.NEW_COMPANY' ), classes: ['control-label'] } )
			} );

			formgroup = this.m_Form.newFormGroup( [ 1 ] );
			const component = new InputSelect( { name: 'componentID', classes: [ 'form-control' ] }, {} );
			this.ComponentSelect = $( component.getElement() );
			this.ComponentSelect.hide();

			formgroup.addItem(
			{
				input: component,
				label: new InputLabel( { value: app.getMessage( 'Account.New.NEW_COMPONENT' ), classes: ['control-label'] } )
			} );

			new Wollmilch.AJAX(
				{
					url: 'organization/list/Company',
					method: 'GET',
					on:
					{
						success: ( text: string ) =>
						{
							const obj = Wollmilch.jsonize( text );

							if ( !obj )
							{
								app.addToast(
									{
										body: [ app.getSpanMessage( 'Account.New.ERROR-NO-COMPANY' ) ],
										timeout: Number(app.getConfigValue("ToastTimeout"))
									}
								);

								return;
							}

							for ( const i in obj.data )
							{
								const d = obj.data[ i ];

								$(select.getElement()).append(
									$( document.createElement( 'option' ) ).append( ui.text( d.Name ) ).attr( 'value', d.ID.toString() )
								);
							}

							$(select.getElement()).on(
								'change',
								() => {
									if ( $(select.getElement()).val() == '' )
									{
										this.ComponentSelect.empty();
										this.ComponentSelect.hide();

										return;
									}
									this.ComponentSelect.show();
									new Wollmilch.AJAX(
										{
											url: 'organization/deeplist/' + $(select.getElement()).val(),
											method: 'GET',
											on:
											{
												success: ( text: string ) =>
												{
													const obj = Wollmilch.jsonize( text );

													if ( !obj )
													{
														app.addToast(
														{
															body: [ app.getSpanMessage( 'Account.New.ERROR-NO-DEEPLIST' ) ],
															timeout: Number(app.getConfigValue("ToastTimeout"))
														} );
														return;
													}

													this.ComponentSelect.empty();
													this.ComponentSelect.append(
														$( document.createElement( 'option' ) ).append( ui.text( app.getMessage( 'AUX.please_select' ) ) ).attr( 'selected', 'selected' ).val( '' )
													);
													for ( const i in obj.data )
													{
														const c = obj.data[ i ];

														if ( typeof c.Account === 'number' ) { continue; }

														this.ComponentSelect.append(
															$( document.createElement( 'option' ) ).attr( 'value', c.ID.toString() ).append( ui.text( c.Name ) )
														);
													}
												}
											}
										}
									).send();
								}
							);
						}
					}
				}
			).send();

			this.m_Form.addButton(
				new Button(
					{
						title: 'Abbrechen',
						style: 'danger',
						classes: [ 'pull-right' ],
						on:
						{
							// click: ( ( entry: ui.tab.Entry ) => { return () => { app.getGlobalTabControl().removeTab( entry ); } } )( this.m_Entry )
						}
					}
				)
			);

			this.m_Form.addButton(
				new Button(
					{
						title: 'Zurücksetzen',
						style: 'primary',
						classes: [ 'pull-right' ],
						on:
						{
							click: ((form: Form) => () => { const inputs = form.Inputs(); for ( const i in inputs ) { $( inputs[ i ].getElement() ).val( '' ); } } )(this.m_Form)
						}
					}
				)
			);

			this.m_Form.addButton(
				new Button(
					{
						title: 'Anlegen',
						style: 'success',
						classes: [ 'pull-right' ],
						on:
						{
							click: (
								( _THIS_: New ) =>
								{
									return () =>
									{
										const inputs = _THIS_.m_Form.Inputs();
										for ( const i in inputs )
										{
											// Überprüfung, dass Feld gefüllt ist
											if ( inputs[ i ].Value() === '' )
											{
												app.addToast(
												{
													body: [ app.getSpanMessage( 'Account.New.FORM_INCOMPLETE' ) ],
													context: 'danger',
													timeout: Number(app.getConfigValue("ToastTimeout"))
												});
												return;
											}
										}

										new Wollmilch.AJAX(
											{
												url: 'account/new',
												method: 'POST',
												on:
												{
													beforeSend: ( o: Wollmilch.IAJAXOptions ) =>
													{
														o.data = {};

														for ( const i in inputs )
														{
															o.data[ inputs[ i ].Name() ] = inputs[ i ].Value();
														}
													},
													success: ( text: string ) =>
													{
														const obj = Wollmilch.jsonize( text );

														if ( !obj )
														{
															app.addToast(
															{
																body: [ app.getSpanMessage( 'Account.New.ERROR' ) ],
																context: 'danger',
																timeout: Number(app.getConfigValue("ToastTimeout"))
															} );

															return;
														}
														else
														{
															if ( obj.success )
															{
																app.addToast(
																{
																	body: [ app.getSpanMessage( 'Account.New.SUCCESS' ) ],
																	context: 'success',
																	timeout: Number(app.getConfigValue("ToastTimeout"))
																} );
															}
															else
															{
																app.addToast(
																{
																	body: [ app.getSpanMessage( 'Account.New.ERROR' ) ],
																	context: 'danger',
																	timeout: Number(app.getConfigValue("ToastTimeout"))
																} );
															}
														}
													}
												}
											}
										).send();
									};
								}
							)(this)
						}
					}
				)
			);

		}
	}
}
